import { Authenticator } from '@aws-amplify/ui-react'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import '@aws-amplify/ui-react/styles.css'
import styles from './Login.module.css'

function Login() {
    const navigate = useNavigate()

    useEffect(() => {
        checkIfAlreadyAuthenticated()
    }, [])

    const checkIfAlreadyAuthenticated = async () => {
        try {
            const session = await fetchAuthSession()
            if (session.tokens) {
                navigate('/dashboard')
            }
        } catch (error) {
            // Not authenticated, stay on login page
        }
    }

    return (
        <div className={styles.loginPage}>
            <div className={styles.container}>
                <div className={styles.loginCard}>
                    <div className={styles.header}>
                        <img src="/logo.png" alt="Ingconia Logo" className={styles.logo} />
                        <h1 className={styles.title}>Bienvenido a Ingconia</h1>
                        <p className={styles.subtitle}>Inicia sesión para acceder a tus herramientas</p>
                    </div>

                    <Authenticator
                        components={{
                            Header: () => null,
                            SignIn: {
                                Header: () => <div className={styles.formTitle}>Iniciar Sesión</div>
                            },
                            SignUp: {
                                Header: () => <div className={styles.formTitle}>Crear Cuenta</div>
                            }
                        }}
                    >
                        {({ signOut, user }) => {
                            if (user) {
                                navigate('/dashboard')
                                return null
                            }
                            return null
                        }}
                    </Authenticator>
                </div>
            </div>
        </div>
    )
}

export default Login
